import IReason from '../../../api-clients/IReason';
import IShouldReturnEntity from '../../../api-clients/IShouldReturnEntity';
import { Entry } from 'contentful';

export class ExcludedEntitiesHelper {
  public shouldPageBeReturned(
    entity: string,
    entry: Entry<any>,
    pageUrl: string,
    requiredFields: string[],
    notEmptyFields: string[],
  ) {
    return this.shouldReturnEntity('page', entity, entry, pageUrl, requiredFields, notEmptyFields);
  }

  public shouldComponentBeReturned(
    entity: string,
    entry: Entry<any>,
    requiredFields: string[],
    notEmptyFields: string[],
  ) {
    return this.shouldReturnEntity('component', entity, entry, '', requiredFields, notEmptyFields);
  }

  protected shouldReturnEntity(
    type: 'page' | 'component',
    entity: string,
    entry: Entry<any>,
    pageUrl: string,
    requiredFields: string[],
    notEmptyFields: string[],
  ): IShouldReturnEntity {
    let shouldReturn = true;
    let shouldNotReturnReasons: IReason[] = [];

    requiredFields.forEach((f) => {
      const subfields = f.split('.');
      let result: any = entry;

      for (const pathPart of subfields) {
        if (result && result.hasOwnProperty(pathPart)) {
          result = result[pathPart];
        } else {
          result = undefined;
        }
      }

      if (!result) {
        shouldReturn = false;
        shouldNotReturnReasons.push({
          entityType: type,
          entity: entity,
          pageUrl: pageUrl,
          field: f,
          reason: 'undefined',
        });
      }
    });

    notEmptyFields.forEach((f) => {
      const subfields = f.split('.');
      let result: any = undefined;

      for (const pathPart of subfields) {
        if (result && result.hasOwnProperty(pathPart)) {
          result = result[pathPart];
        } else {
          result = undefined;
        }
      }

      if (
        (result && typeof result === 'string' && result.trim() == '') ||
        Array.isArray(result && result.length > 0)
      ) {
        shouldReturn = false;
        shouldNotReturnReasons.push({
          entityType: type,
          entity: entity,
          pageUrl: pageUrl,
          field: f,
          reason: 'empty',
        });
      }
    });

    return { shouldReturn: shouldReturn, shouldNotReturnReasons: shouldNotReturnReasons };
  }
}
